import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

// Mirrors the full left nav of the current product so switching between the
// real compliance view and this prototype feels like the same app. Only
// Findings → Compliance is live; every other item lands on the placeholder
// page (the SOL navbar has no disabled/dead item state).
//
// The trailing "←" on Assets, Compliance and Workflows is a dev hint — it marks
// the pages this prototype actually touched. The nav has no per-item emphasis
// (no bold/badge), so a marker in the label is the clean way to flag them.
export const dev18073ComplianceNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_asset_groups, {
      displayName: 'Asset groups',
      icon: SolIcon.asset_group,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_assets, {
      displayName: 'Assets ←',
      icon: SolIcon.asset,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_findings, {
      displayName: 'Findings',
      icon: SolIcon.finding,
      children: [
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_vulnerabilities, {
          displayName: 'Vulnerabilities',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_informational, {
          displayName: 'Informational',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_compliance, {
          displayName: 'Compliance ←',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_catalog, {
          displayName: 'Catalog',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_configuration, {
      displayName: 'Configuration',
      icon: SolIcon.configuration,
      children: [
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_scan_configurations, {
          displayName: 'Scan configurations',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_rc_scanners, {
          displayName: 'RC scanners',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_scan_policies, {
          displayName: 'Scan policies',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_view_templates, {
          displayName: 'View templates',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_credentials, {
          displayName: 'Credentials',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_integrations, {
          displayName: 'Integrations',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_notification_settings, {
          displayName: 'Notification settings',
        }),
        SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_workflows, {
          displayName: 'Workflows ←',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_automation, {
      displayName: 'Automation',
      icon: SolIcon.automation,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_scans, {
      displayName: 'Scans',
      icon: SolIcon.scan,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_report_library, {
      displayName: 'Report library',
      icon: SolIcon.report,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_tags, {
      displayName: 'Tags',
      icon: SolIcon.tags,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_subscriptions, {
      displayName: 'Subscriptions',
      icon: SolIcon.subscription,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_consumption, {
      displayName: 'Consumption',
      icon: SolIcon.usage,
    }),
    SolNavbarItem.of(PrototypeRouteId.dev_18073_compliance_appliances, {
      displayName: 'Appliances',
      icon: SolIcon.appliance,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
